import React, {Fragment} from 'react'

import {
  EuiBreadcrumbs,
  EuiSpacer
} from '@elastic/eui'


export default function ManualBreadcrumbs() {

  const breadcrumbs = [
    {
      text: 'Übersicht',
      href: '/de/Innenkameras/IN-8401_WQHD/',
    },
    {
      text: 'Spezifikationen',
      href: '/de/Innenkameras/IN-8401_WQHD/Technische_Spezifikationen/',
    },
    {
      text: 'Features',
      href: '/de/Innenkameras/IN-8401_WQHD/Produkt_Features/',
    },
    {
      text: 'Installation',
      href: '/de/Innenkameras/IN-8401_WQHD/Schnell_Installation/',
    },
    {
      text: 'Objektivjustage',
      href: '/de/Innenkameras/IN-8401_WQHD/Objektivjustage/',
    },
    {
      text: 'Handbuch',
      href: '/de/Innenkameras/IN-8401_WQHD/Handbuch/',
    },
    {
      text: '◄ Innenkameras',
      href: '/de/Innenkameras/',
    }
  ];

  return (
    <Fragment>
      <EuiBreadcrumbs
        truncate={true}
        breadcrumbs={breadcrumbs}
        max={10}
        aria-label="INSTAR IN-8401 2k+ WQHD Online Handbuch Kapitel"
      />
      <EuiSpacer />
    </Fragment>
  );
}